import services from 'services';
import { BANK_TRANSFER_URL, UPLOAD_PROOF_BANK_URL } from 'consts/api';

class InvoiceServices {
  addOrder({ amount } = {}) {
    return services.get(`${BANK_TRANSFER_URL}/add?amount=${amount}`);
  }

  listTransaction(
    body = {
      type: '',
      start: null,
      end: null,

      offset: 0,
      limit: 50,

      //* Bank type
      statuses: [],
    }
  ) {
    return services.post(`${BANK_TRANSFER_URL}/list`, body);
  }

  uploadProof({ orderId, file }) {
    const form = new FormData();
    if (file) {
      form.append('file', file);
    }

    return services.post(`${UPLOAD_PROOF_BANK_URL}?orderId=${orderId}`, form);
  }

  downloadProof({ orderId, proofId }) {
    return services.get(`${BANK_TRANSFER_URL}/pop/download?orderId=${orderId}&proofId=${proofId}`, {
      responseType: 'blob',
    });
  }

  deleteProof({ orderId, proofId }) {
    return services.get(`${BANK_TRANSFER_URL}/pop/delete?orderId=${orderId}&proofId=${proofId}`);
  }
}

export default new InvoiceServices();
